import { Box } from 'components/Box';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { TrackedConditionalLink } from 'components/Link';
import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { H2 } from 'components/Text/H2';
import { CmsApiImageBlockData } from 'modules/cms/api/types/blocks/CmsApiImageBlock';

type Props = {
  data: CmsApiImageBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsAmpImageBlock({
  data: { headline, subtitle, image, url },
  blockIndex,
  pageUpdated,
}: Props) {
  const { caption, altText } = image;

  return (
    <figure style={{ width: '100%', margin: 0 }}>
      {(headline || subtitle) && (
        <figcaption style={{ marginBottom: 48 }}>
          {headline && <H2>{headline}</H2>}
          {subtitle && (
            <Body
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </figcaption>
      )}

      <Box
        component={headline || subtitle ? 'figure' : 'div'}
        style={{ margin: 0 }}
      >
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated,
          }}
        >
          <FilestackImage
            data={image}
            alt={altText || ''}
            height={450}
            width={1152}
            objectPosition="left"
          />
        </TrackedConditionalLink>

        {caption && (
          <div style={{ marginTop: 8 }}>
            <BodySmall tag="figcaption">{caption}</BodySmall>
          </div>
        )}
      </Box>
    </figure>
  );
}
